// extracted by mini-css-extract-plugin
export var section = "section-module--section--YiRvb";
export var sectionSmall = "section-module--sectionSmall--kGVql";